export default function round(value, digits) {
    digits = typeof digits === 'undefined' ? 2 : digits;
    const x = Math.pow(10, digits);
    return Math.round(value * x) / x;
}
